<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <setting-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></setting-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import SettingForm from '../../components/setting/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      SettingForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Configuration Variable'
        }

        return 'Create Configuration Variable'
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-setting-table');
      },
    },

    created() {
      eventBus.$on('show-edit-setting-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-edit-setting-dialog', this.show);
    }
  }
</script>
